import React, { useState } from "react";

import { listColumns, recordTitle, settingsOf, titleField } from "./custom-module-utils";
import { FieldValue } from "./record-fields";

// Kanban view: one column per option of the module's board field. Dragging a
// card to another column calls onMove(record, option) ("" means not set).
const RecordBoard = ({ module, records, counts, canEdit, onOpen, onMove }) => {
  const [dragId, setDragId] = useState(null);
  const [over, setOver] = useState(null);

  const boardKey = settingsOf(module).list.board_field;
  const field = module.fields.find((item) => item.key === boardKey);
  if (!field) return null;

  const titleKey = titleField(module)?.key;
  const details = listColumns(module).filter((item) => item.key !== field.key && item.key !== titleKey).slice(0, 3);
  const optionOf = (record) => record.data?.[field.key] ?? "";

  const drop = (option) => {
    const record = records.find((item) => item.id === dragId);
    setDragId(null);
    setOver(null);
    if (record && optionOf(record) !== option) onMove(record, option);
  };

  return (
    <div className="cm-board">
      {[...field.options, ""].map((option) => {
        const cards = records.filter((record) => optionOf(record) === option);
        const total = counts?.[option] ?? cards.length;
        if (option === "" && !total) return null;
        const color = field.option_colors?.[option] || "#546088";

        return (
          <div
            key={option || "__none"}
            className={`cm-board-col ${over === option ? "cm-drop" : ""}`}
            onDragOver={(e) => {
              if (dragId === null) return;
              e.preventDefault();
              setOver(option);
            }}
            onDragLeave={() => setOver(null)}
            onDrop={(e) => {
              e.preventDefault();
              drop(option);
            }}
          >
            <div className="d-flex align-items-center justify-content-between mb-2 pt-2" style={{ borderTop: `3px solid ${color}` }}>
              <span className="fs-14 fw-600 text-dkblue">{option || "Not set"}</span>
              <span className="fs-12 fw-600 text-grey">{total}</span>
            </div>

            {cards.map((record) => (
              <div
                key={record.id}
                className="cm-board-card"
                draggable={canEdit}
                onDragStart={(e) => {
                  e.dataTransfer.effectAllowed = "move";
                  e.dataTransfer.setData("text/plain", String(record.id));
                  setDragId(record.id);
                }}
                onDragEnd={() => {
                  setDragId(null);
                  setOver(null);
                }}
                onClick={() => onOpen(record)}
              >
                {record.code && <div className="fs-12 fw-600 text-grey">{record.code}</div>}
                <div className="fs-14 fw-600 text-dkblue">{recordTitle(module, record)}</div>
                {details.map((item) => (
                  <div key={item.key} className="fs-12 fw-500 text-grey mt-1">
                    <span>{item.label}: </span>
                    <FieldValue field={item} value={record.data?.[item.key]} />
                  </div>
                ))}
              </div>
            ))}
            {total > cards.length && (
              <div className="fs-12 fw-500 text-grey text-center">+{total - cards.length} more, use filters to narrow</div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default RecordBoard;
